import { useAtomValue, useSetAtom } from "jotai";
import { ClipIcon } from "@/icons/widget-menu";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import { applyValue } from "../applyValue";
import { setNewOptions } from "../setNewOptions";

interface UseClipButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function useClipButton({ setActiveSubMenu }: UseClipButtonProps): MenuOptionResult {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("clip"));
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const handleClick = () => {
        setActiveSubMenu(null);

        const setClipOptions = setNewOptions({ name: "clip", setWidgetMenuOptions });

        applyValue({ options, value: "", setNewOptions: setClipOptions });
    };

    return {
        content: <ClipIcon />,
        handleClick,
    };
}
